export default "__VITE_ASSET__C2e0B5$8__"